
export const ROLES = {
  USER: 'user',
  CONTRIBUTOR: 'embajador',
  ADMIN: 'admin',
};
